import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/services/tech-consultation")({
  component: () => <Outlet />,
});
